module.exports = __webpack_public_path__ + "static/media/Pulley.dac7cb5f.svg";